import {
  ActivityProgressFilterParams,
  listActivityProgress,
} from '@/data/services/activityProgressServices';

export const activityProgressQueries = {
  all: ['activitiesProgresses'] as const,

  list: (filters: ActivityProgressFilterParams = {}) => ({
    queryKey: [...activityProgressQueries.all, 'list', { filters }] as const,
    queryFn: () => listActivityProgress(filters),
  }),
};
